import { salesDataClientSourceReject } from 'commons/service/bank/salesData'
import { SalesDataClientSourceRejectPayload } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSalesDataClientSourceReject: WriteHook<SalesDataClientSourceRejectPayload, void> = (opts) =>
  useMutationManager<SalesDataClientSourceRejectPayload, void>(salesDataClientSourceReject, opts)
